<template>
  <b-modal
    v-model="showModal"
    :title="`Adicionar ${levelLabel}`"
    size="xl"
    scrollable
    ok-title="Salvar"
    cancel-title="Cancelar"
    centered
    @ok.prevent="submit"
    @hidden="onHidden"
  >
    <b-tabs pills card vertical class="edit-menu-sidebar">
      <b-tab title="Dados Básicos" active>
        <DadosBasicos />
      </b-tab>
      <b-tab title="ODS">
        <Ods />
      </b-tab>
      <b-tab title="Indicadores">
        <Indicadores />
      </b-tab>
      <b-tab title="Metas">
        <Metas />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import DadosBasicos from "@/modules/objectives/components/Form/DadosBasicos.vue";
import Ods from "@/modules/objectives/components/Form/Ods.vue";
import Indicadores from "@/modules/objectives/components/Form/Indicadores.vue";
import Metas from "@/modules/objectives/components/Form/Metas.vue";
import services from "@/http";
import { mapState, mapActions } from "vuex";

export default {
  components: { DadosBasicos, Ods, Indicadores, Metas },
  props: {
    strategicPlanId: { type: [Number, String], required: true },
  },
  data: () => ({
    showModal: false,
    parentId: null,
    depth: 0,
  }),
  computed: {
    ...mapState("strategic_plans", ["strategic_plan"]),
    ...mapState("objectives", ["objective"]),
    planLevels() {
      return this.strategic_plan?.config?.plan_structure?.levels || [];
    },
    levelLabel() {
      const defaults = ["Nível 1", "Nível 2", "Nível 3", "Nível 4", "Nível 5"];
      return this.planLevels[this.depth] || defaults[this.depth] || `Nível ${this.depth + 1}`;
    },
  },
  methods: {
    ...mapActions("objectives", ["ActionSetOjective", "ActionGetOds"]),
    show(parentId, depth = 0) {
      this.parentId = parentId;
      this.depth = depth;
      this.showModal = true;

      this.ActionSetOjective({
        id: null,
        name: "",
        description: "",
        indicators: [],
        measures: [],
        ods: [],
        _is_plan_structure: true,
      });
      this.ActionGetOds();
    },
    onHidden() {
      this.ActionSetOjective(null);
    },
    async submit() {
      if (!this.objective || !this.objective.name || !this.objective.name.trim()) {
        this.$notifications.addNotification({
          message: "O nome é obrigatório.",
          type: "danger",
        });
        return;
      }

      const maxDepth = this.planLevels?.length ?? 1;
      if (this.depth >= maxDepth) {
        this.$notifications.addNotification({
          message: `Limite máximo de ${maxDepth} níveis atingido.`,
          type: "warning",
        });
        return;
      }

      try {
        const { data: created } = await services.strategic_plans.store_plan_structure({
          name: this.objective.name,
          description: this.objective.description || null,
          parent_id: this.parentId,
          strategic_plan_id: this.strategicPlanId,
        });

        const planStruct = created?.plan_structure ?? created;
        const newId = planStruct?.id;
        if (newId && (this.objective.ods?.length || this.objective.indicators?.length)) {
          await services.strategic_plans.plan_structure_update_full(
            { id: newId },
            {
              name: this.objective.name,
              description: this.objective.description || null,
              ods: this.objective.ods || [],
              indicators: this.objective.indicators || [],
            }
          );
        }

        this.$notifications.addNotification({
          message: `${this.levelLabel} salvo com sucesso!`,
          type: "success",
        });
        this.showModal = false;
        this.$emit("saved");
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          `Erro ao salvar ${this.levelLabel.toLowerCase()}.`;
        this.$notifications.addNotification({
          message: msg,
          type: "danger",
        });
      }
    },
  },
};
</script>
